import React from 'react';
export const UserContext = React.createContext({
    manufacturerId: null,
    setManufacturerId: () => { },
    forceInvokeApp: () => { }
});